import { render } from "./Barman.vue?vue&type=template&id=62c2b344&scoped=true"
import script from "./Barman.vue?vue&type=script&lang=js"
export * from "./Barman.vue?vue&type=script&lang=js"

import "./Barman.vue?vue&type=style&index=0&id=62c2b344&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c2b344"]])

export default __exports__